export default "__VITE_ASSET__BaQeNco8__"